import { ProgressBarWithValueCell, TextCell } from "@similarweb/pro-logic-components";
import type { ColumnsType } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";
import { renderWebsiteTooltipCell } from "app/pages/digital-marketing/ad-intelligence/common/utils/websiteTooltipCell";

import { formatPercentValue } from "../../utils/utils";

import type { IIndustryPublisherPreviewRow } from "./useIndustryTopPublishersPreview";

const SHARE_VALUE_MIN_WIDTH = "48px";

const renderShareCell = (share: number) => (
    <ProgressBarWithValueCell
        share={share}
        value={formatPercentValue(share)}
        color={colorsPalettes.blue[400]}
        valueMinWidth={SHARE_VALUE_MIN_WIDTH}
    />
);

export const getColumns = (
    onPublisherClick: (publisher: string) => void,
): ColumnsType<IIndustryPublisherPreviewRow> => [
    {
        title: () => (
            <TextCell
                fontVariant="captionTitle"
                color={colorsPalettes.carbon[300]}
            >
                {translate("ad.intelligence.overview.top.publishers.column.title")}
            </TextCell>
        ),
        dataIndex: "publisher",
        render: (publisher: string) =>
            renderWebsiteTooltipCell(publisher, {
                onDomainClick: onPublisherClick,
                dataAutomation: "industry-top-publishers-publisher-link",
            }),
    },
    {
        // `.excel.column.title` renders the full "Spend Share" label; the plain
        // `.share.column.title` renders just "Share" (it's a child of a metric group).
        title: translate("ad.intelligence.advertiser.publishers.spend.share.excel.column.title"),
        dataIndex: "spendShare",
        render: (spendShare: number) => renderShareCell(spendShare),
    },
    {
        title: translate("ad.intelligence.advertiser.publishers.impressions.share.excel.column.title"),
        dataIndex: "impressionsShare",
        render: (impressionsShare: number) => renderShareCell(impressionsShare),
    },
    {
        title: translate("ad.intelligence.advertiser.publishers.visits.share.excel.column.title"),
        dataIndex: "visitsShare",
        render: (visitsShare: number) => renderShareCell(visitsShare),
    },
];
